<template>
    <section>

        <div class="row">
            <div v-if="edited_lists && edited_lists[0]" class="col-12 mb-4">
                <div class="card shadow p-2 position-relative list">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 mb-1 mt-3 fs-5 fs-mobile-6">
                                <h1 class="h3 mb-0 text-black page-title">Bine ai revenit!</h1>
                                <p>Acestea sunt listele pe care le-ai editat în trecut pe acest dispozitiv:</p>
                                <div v-for="(list, index) in edited_lists" class="row no-gutters mt-1" :class="{'bg-gray-200': index%2!=0, 'bg-light': index%2==0}">
                                    <div class="col-8 pl-3 pt-1 pt-md-0">{{list.name}}</div>
                                    <div class="col-4 text-right">
                                        <button @click="goToEditLink(list)" v-tooltip="'Editează lista'" class="btn btn-secondary btn-sm btn-warning" type="button"><i class="text-white fa-solid fa-pencil fs-5 fs-mobile-6"></i></button>
                                        <button @click="goToViewLink(list)" v-tooltip="'Vezi lista'" class="btn btn-secondary btn-sm btn-success ml-2" type="button"><i class="text-white fa-solid fa-magnifying-glass fs-5 fs-mobile-6"></i></button>
                                        <button @click="removeList(index)" v-tooltip="'Ascunde lista de pe dispozitiv'" class="btn btn-secondary btn-sm btn-danger ml-2" type="button"><i class="text-white fa-solid fa-eye-slash fs-5 fs-mobile-6"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 mb-4">
                <div class="card shadow p-2 position-relative list">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 mb-4 fs-5 fs-mobile-6">
                                <h1 v-if="!edited_lists || !edited_lists[0]" class="h3 mb-0 text-black page-title">Bine ai venit!</h1>
                                <p><strong>Din Raft</strong> este un marketplace pentru jocuri de societate. Aici poți <strong>pune la vânzare</strong> jocurile tale printr-un proces simplu de import și catalogare sau poți <strong>găsi cele mai bune oferte</strong> postate de ceilalți membrii!</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 fs-5 fs-mobile-6">
                                <div @click="switchTab('buy')" class="card text-center cursor-pointer shadow" :class="{'bg-orange': tab=='buy', 'bg-white': tab!='buy', 'text-white': tab=='buy', 'text-muted': tab!='buy'}">
                                    <div class="card-body">
                                        Vreau să văd ce pot cumpăra de la alții
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 fs-5 fs-mobile-6">
                                <div @click="switchTab('sell')" class="card text-center cursor-pointer shadow" :class="{'bg-orange': tab=='sell', 'bg-white': tab!='sell', 'text-white': tab=='sell', 'text-muted': tab!='sell'}">
                                    <div class="card-body">
                                        Vreau să vând propriile jocuri
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="tab=='buy'" class="row">
            <div class="col-12 mb-4">
                <div class="card shadow p-2 position-relative list bg-orange-light">
                    <div class="card-body">
                        <div class="d-sm-flex align-items-center justify-content-between mb-1 mt-3">
                            <h5 class="h5 mb-0">Caută un joc pe listele <strong>Din Raft</strong>:</h5>
                        </div>
                        <div class="d-inline-block form-inline mr-auto w-100 my-2 my-md-0 mw-100 navbar-search">
                            <div class="">
                                <autocomplete
                                    url="https://boardgamegeek.com/xmlapi2/search" param="search" :customParams="{ type: 'boardgame' }"
                                    class="w-100"
                                    :classes="{input: 'w-100 form-control bg-light border-0 small'}" placeholder="Numele jocului"
                                    anchor="value"
                                    label="label"
                                    :debounce="300"
                                    :onShouldGetData="onSearchGame"
                                    :onShouldRenderChild="renderSearchGame"
                                    :on-select="onSelectGame"
                                    ref="autocomplete">
                                </autocomplete>
                            </div>
                            <p class="mb-0 mt-2 small text-left" :class="{ 'text-danger': bgg_searching_color=='danger', 'text-success': bgg_searching_color=='success' }">{{ bgg_searching_msg }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="(game, i) in games" :key="games[i].list_id" :bgg-id="games[i].id">
                <search-item :item="game" :index="i"></search-item>
            </div>

            <div class="col-12 mb-4" id="lists">
                <h2 class="h2 text-center mt-5 text-">Ultimele liste adăugate:</h2>
            </div>

            <div v-if="!lists_loaded" class="loader"><span></span></div>
            <div v-for="(list, i) in published_lists">
                <list-item :item="list" :index="i"></list-item>
            </div>

            <div v-if="loading_more" class="loader"><span></span></div>
            <div v-if="lists_loaded && has_more_published" class="col-12 text-center">
                <button type="button" class="btn btn-primary btn-success" @click="loadMorePublished" :disabled="loading_more">Vezi mai multe</button>
            </div>

            <div class="col-12 mb-4">
                <h2 class="h2 text-center mt-5 text-">Ultimele liste actualizate:</h2>
            </div>

            <div v-if="!lists_loaded" class="loader"><span></span></div>
            <div v-for="(list, i) in updated_lists">
                <list-item :item="list" :index="i"></list-item>
            </div>
            <div v-if="loading_more_updated" class="loader"><span></span></div>
            <div v-if="lists_loaded && has_more_updated" class="col-12 text-center">
                <button type="button" class="btn btn-primary btn-success" @click="loadMoreUpdated" :disabled="loading_more_updated">Vezi mai multe</button>
            </div>
        </div>















        <div v-if="tab=='sell'" class="row">
            <div class="col-12 mb-4">
                <div class="card shadow p-2 position-relative list">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mb-1 mt-3 fs-5 fs-mobile-6">
                                <p>Dacă ai jocuri de societate pe care vrei să le scoți la vânzare, ai ajuns în locul potrivit.</p>
                                <p>
                                    <strong>Din Raft</strong> este o aplicație care te poate ajuta:
                                    <ul class="list-unstyled">
                                        <li><i class="fa-solid fa-check text-success pr-2"></i> <strong>Importă</strong> jocurile marcate din <strong>colecția ta</strong> BoardGameGeek</li>
                                        <li><i class="fa-solid fa-check text-success pr-2"></i> <strong>Setează</strong> automat <strong>condiția jocului</strong> în funcție de numărul de partide jucate</li>
                                        <li><i class="fa-solid fa-check text-success pr-2"></i> <strong>Afișează</strong> instant <strong>cel mai mic preț</strong> disponibil în magazine pentru fiecare joc</li>
                                        <li><i class="fa-solid fa-check text-success pr-2"></i> <strong>Sugerează</strong> un <strong>preț adecvat</strong> în funcție de condiția jocului și prețul pieței</li>
                                        <li><i class="fa-solid fa-check text-success pr-2"></i> Desigur poți <strong>modifica orice</strong> e nevoie</li>
                                        <li><i class="fa-solid fa-check text-success pr-2"></i> La final ai o <strong>pagină proprie</strong> cu toate informațiile la care <strong>poți da share</strong> pe grupuri</li>
                                        <li><i class="fa-solid fa-check text-success pr-2"></i> În plus <strong>poți publica</strong> lista <strong>pe HowToPlay.ro</strong> să afle toată lumea!</li>
                                    </ul>
                                </p>
                            </div>
                            <div class="col-md-6">
                                <img src="/img/ss.jpg" alt="" class="w-100">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 mb-4">
                <div class="card shadow p-2 position-relative list">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mt-3 fs-5 fs-mobile-6">
                                <h1 class="h3 mb-0 text-black page-title">Te-am convins?</h1>
                                <p>Hai să începem! Pentru a importa doar jocurile pe care vrei să le vinzi din colecție trebuie să le modifici statusul în BoardGameGeek în "<strong>For Trade</strong>", apoi pune mai jos userul de la care vrei să tragem lista.</p>
                            </div>
                            <div class="col-md-6">
                                <img src="/img/bgg.jpg" alt="" class="w-100">
                            </div>
                            <div class="col-md-6 mt-3 fs-5 fs-mobile-6">
                                <p>Altfel, poți să creezi o listă nouă adăugand manual jocuri.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 mb-4">
                <div class="card shadow p-2 h-100 position-relative">
                    <div class="card-body">
                        <form @submit="createList" class="d-inline-block form-inline mr-auto w-100 my-2 my-md-0 mw-100 navbar-search">
                            <div class="input-group">
                                <input v-model="bgg_user" type="text" class="form-control bg-light border-0 small" placeholder="Username BoardGameGeek "
                                    aria-label="Search" aria-describedby="basic-addon2">
                                <div class="input-group-append">
                                    <button class="btn btn-primary btn-success py-0 py-md-1" type="submit" :disabled="!bgg_user">Importă</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-4">
                <div class="card new-list shadow p-2 h-100 position-relative">
                    <div class="card-body translate-middle top-50 start-50 position-absolute text-center p-0">
                        sau 
                        <button @click="createList" class="btn btn-primary btn-success ml-2" type="button">Începe o listă nouă</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-4">
                <div class="card p-2 shadow ">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 fs-5 fs-mobile-6">
                                <p>Pentru întrebări sau sugestii poți scrie la <a href="mailto:contact@boardiacs.com" class="text-black">contact@boardiacs.com</a>. Dacă ți-a plăcut aplicația și vrei să ne susții poți să ne faci cinste cu o cafea: </p>
                                <div class="text-center">
                                    <stripe-buy-button
                                      buy-button-id="buy_btn_1OZBr9Biw9lJfmclfYkvke7m"
                                      publishable-key="pk_live_51OZ8ndBiw9lJfmcl9kXQTdlridPDyRs502YuftzaMFGOHopCthTVEJvTyobZxEAWJKg1lh0G9oxS65Le2FrCFChW00vVHcZUHX"
                                    ></stripe-buy-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




    </section>
</template>
<script>
    import Vue from "vue";
    import HelperMixin from "../../mixins/HelperMixin";
    import VTooltip from 'v-tooltip'
    import SearchItem from '../SearchItem'
    import ListItem from '../ListItem'
    import Autocomplete from 'vue2-autocomplete-js'

    Vue.use(VTooltip);

    export default {
        name: "Home",
        components: {Autocomplete, SearchItem, ListItem},
        mixins: [HelperMixin],
        props: [],
        computed: { },
        data() {
            return {
                bgg_user: '',
                tab: 'buy',
                games: [],
                edited_lists: [],
                lists_loaded: false,
                loading_more: false,
                has_more_published: true,
                loading_more_updated: false,
                has_more_updated: true,
                published_lists: [],
                updated_lists: [],
                search_games: []
            }
        },
        created() {
            var _this = this;
            let edited_lists = localStorage.edited_lists;
            if(edited_lists) {
                _this.edited_lists = JSON.parse(edited_lists);
            } else {
                _this.edited_lists = [];
            }
        },
        mounted () {
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();
            
            // Add event listener to prevent dropdown closing on checkbox clicks
            this.$nextTick(() => {
                if (this.$refs.autocomplete && this.$refs.autocomplete.$el) {
                    this.$refs.autocomplete.$el.addEventListener('click', (event) => {
                        if (event.target.type === 'checkbox') {
                            event.stopPropagation();
                            this.handleCheckboxClick(event, event.target.value);
                            return false;
                        }
                    }, true); // Use capture phase
                }
            });
        },
        unmounted () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        destroyed() {
        },
        methods: {
            createList: function(event) {
                if (event !== undefined) {
                    event.preventDefault();
                }
                this.$router.push({ name: "create-list", params: { bgg_user: this.bgg_user } });
            },
            goToViewLink: function(list) {
                this.$router.push({ name: "view-list", params: { list_id: list.id } }).catch(err => {});
            },
            goToEditLink: function(list) {
                this.$router.push({ name: "edit-list", params: { list_id: list.edit_id } }).catch(err => {});
            },
            removeList: function(index) {
                this.edited_lists.splice(index, 1);
                localStorage.edited_lists = JSON.stringify(this.edited_lists);
            },
            switchTab: function(tab) {
                this.tab=tab;
            },
            onSelectGame: function (selected){
                var _this = this;
                this.$refs.autocomplete.type = '';

                _this.bgg_searching_msg = ''; 

                if(_this.search_games.indexOf(parseInt(selected.id)) == -1) {
                    _this.search_games.push(selected.id);
                }

                $.ajax({
                    type: "POST",
                    url: api_url+ ('/games/search'),
                    dataType: 'json',
                    processData : false,
                    data: JSON.stringify({ ids: _this.search_games })
                }).always(function(data){
                    if(typeof data[0] != "undefined" && typeof data[0].id != "undefined") {
                        _this.games = data;
                    } else {
                        _this.bgg_searching_color = 'danger';
                        _this.bgg_searching_msg = 'Nu am găsit jocul la vânzare pe listele publicate Din Raft.';
                    }

                    $('#autocomplete-style').text('');
                    _this.search_games = [];
                });
            },
            handleCheckboxClick: function(event, gameId) {
                var _this = this;
                event.stopPropagation();

                if(event.target.checked) {
                    _this.search_games.push(parseInt(gameId));
                } else {
                    var index = _this.search_games.indexOf(parseInt(gameId));
                    if (index > -1) { 
                      _this.search_games.splice(index, 1); 
                    }
                }
                
                // Keep the dropdown open by forcing display style
                if (_this.$refs.autocomplete) {
                    _this.$refs.autocomplete.showList = true;
                    
                    $('#autocomplete-style').text('.autocomplete-list { display: block!important; }');
                }
            },
            handleScroll (event) {
                var _this = this;
                if(!_this.lists_loaded && $('#lists').length) {
                    var widgetTop = $('#lists').offset().top;
                    var widgetBottom = $('#lists').offset().top + $('#lists').outerHeight();
                    var viewportTop = $(window).scrollTop();
                    var viewportBottom = viewportTop + $(window).height();

                    if ((viewportBottom >= widgetTop) && (viewportTop <= widgetBottom)) {
                        _this.lists_loaded = true;
                        $.ajax({
                            type: "POST",
                            url: api_url+ ('/lists/get'),
                            dataType: 'json',
                            processData : false
                        }).always(function(data){
                            if(typeof data.published != "undefined" && typeof data.updated != "undefined") {
                                _this.published_lists = _this.prepareLists(data.published);
                                _this.updated_lists = _this.prepareLists(data.updated);
                            }
                        });

                    }
                }
            },
            prepareLists: function(lists) {
                lists.forEach(function(list) {
                    let games = JSON.parse(list.games).filter(function(game){return game.status!='hidden'});
                    list.games = games.slice(0,7);
                    list.games_no = games.length;
                });
                return lists;
            },
            loadMorePublished: function() {
                var _this = this;
                if(_this.loading_more) {
                    return;
                }
                _this.loading_more = true;
                const limit = 20;
                $.ajax({
                    type: "POST",
                    url: api_url+ ('/lists/get'),
                    dataType: 'json',
                    processData : false,
                    data: JSON.stringify({ offset: _this.published_lists.length, limit: limit })
                }).done(function(data){
                    if(data && Array.isArray(data.published)) {
                        let existing_ids = _this.published_lists.map(function(list){ return list.id; });
                        let new_lists = _this.prepareLists(data.published).filter(function(list){ return existing_ids.indexOf(list.id) == -1; });
                        _this.published_lists = _this.published_lists.concat(new_lists);
                        _this.has_more_published = data.published.length === limit;
                    }
                }).always(function(){
                    _this.loading_more = false;
                });
            },
            loadMoreUpdated: function() {
                var _this = this;
                if(_this.loading_more_updated) {
                    return;
                }
                _this.loading_more_updated = true;
                const limit = 20;
                $.ajax({
                    type: "POST",
                    url: api_url+ ('/lists/get'),
                    dataType: 'json',
                    processData : false,
                    data: JSON.stringify({ type: 'updated', offset: _this.updated_lists.length, limit: limit })
                }).done(function(data){
                    if(data && Array.isArray(data.updated)) {
                        let existing_ids = _this.updated_lists.map(function(list){ return list.id; });
                        let new_lists = _this.prepareLists(data.updated).filter(function(list){ return existing_ids.indexOf(list.id) == -1; });
                        _this.updated_lists = _this.updated_lists.concat(new_lists);
                        _this.has_more_updated = data.updated.length === limit;
                    }
                }).always(function(){
                    _this.loading_more_updated = false;
                });
            }
        }
    };
</script>
